export const SET_PRAYERS = 'SET_PRAYERS';
export const SET_PRAYER = 'SET_PRAYER';
export const ADD_PRAYER = 'ADD_PRAYER';
export const UPDATE_PRAYER = 'UPDATE_PRAYER';
export const REMOVE_PRAYER = 'REMOVE_PRAYER';
export const CLEAR_PRAYER = 'CLEAR_PRAYER';
export const CLEAR_PRAYERS = 'CLEAR_PRAYERS';
